import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'
import {apiBaseUrl} from './assets/js/request/axios';
import VueMeta from 'vue-meta';

Vue.use(ElementUI)
Vue.use(VueMeta);

Vue.config.productionTip = false

Vue.prototype.$baseUrl = apiBaseUrl

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
